import React, {Fragment} from 'react';
import {connect} from 'react-redux';
interface propiedades {
  styles: {
    colors: {
      primary: string;
      base: string;
      secondary: string;
    };
    background: string;
  };
}

interface configObject {
  configReducer: {
    siteConfig: propiedades;
  };
}

const StyleConfig = (props: propiedades) => {
  return (
    <Fragment>
      <style>
        {Object.entries(props.styles.colors).map(([key, value]) => {
          return `
                   .background-${key}{
                     background-color: ${value}
                   }
                   .color-${key} {
                     color: ${value}
                   }
                   .border-${key} {
                     border-color: ${value} !important
                   }
                   .after-border-${key}:after{
                        border-color: ${value} transparent ${value} transparent
                    }
                 `;
        })}
        {`.react-tags-wrapper .tag-wrapper{
                    background-color: ${props.styles.colors.secondary};
                }
              .back-image{
                background-image: url(${props.styles.background})
              }
            `}
      </style>
    </Fragment>
  );
};

const mapStateToProps = (state: configObject) => {
  return {
    styles: state.configReducer.siteConfig.styles,
  };
};
export default connect(mapStateToProps)(StyleConfig);
